import { render, staticRenderFns } from "./form-field-file.vue?vue&type=template&id=67b5b314&scoped=true&"
import script from "./form-field-file.vue?vue&type=script&lang=js&"
export * from "./form-field-file.vue?vue&type=script&lang=js&"
import style0 from "./form-field-file.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./form-field-file.vue?vue&type=style&index=1&id=67b5b314&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "67b5b314",
  null
  
)

export default component.exports